import { useQueryGetSubProgramPreferenceInfo } from 'api/queries/getSubProgramPreferenceInfo.query';

import { WidgetTitle } from 'components/common/WidgetTitle/WidgetTitle';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import classes from 'components/widgets/SubProgramPreferences/SubProgramPreferences.module.scss';
import { ExcelExport } from 'components/widgets/SubProgramPreferences/components/ExcelExport/ExcelExport';
import { ImportantActivities } from 'components/widgets/SubProgramPreferences/components/ImportantActivities/ImportantActivities';
import { OverdueAndUrgentDateThreshold } from 'components/widgets/SubProgramPreferences/components/OverdueAndUrgentDateThreshold/OverdueAndUrgentDateThreshold';
import { TagList } from 'components/widgets/SubProgramPreferences/components/TagList/tagList';
import { ProgressMeasurement } from 'components/widgets/SubProgramPreferences/components/progressMeasurement/progressMeasurement';

export const SubProgramPreferences = () => {
    const { data } = useQueryGetSubProgramPreferenceInfo();

    return (
        <WidgetWithTitle title={<WidgetTitle title={'Sub Program Preferences'} />} tooltip={data}>
            <div className={classes.formContainer}>
                <p className={classes.note}>
                    You will be prompted to confirm in case you make any changes to the sub program preferences.
                </p>
                <div className={classes.inputWrapper}>
                    <TagList />
                </div>
                <div className={classes.inputWrapper}>
                    <ProgressMeasurement />
                </div>

                <div className={classes.inputWrapper}>
                    <OverdueAndUrgentDateThreshold />
                </div>
                <div className={classes.inputWrapper}>
                    <ImportantActivities />
                </div>
                <div className={classes.inputWrapper}>
                    <ExcelExport />
                </div>
            </div>
        </WidgetWithTitle>
    );
};
